import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { compactArray, primitiveTypeUniq } from '@mews/fp';
import { getReservationPurchaseOrderNumberByIds } from '@mews-commander/legacy-entities/src/ducks/reservationPurchaseOrderNumber';
import { useCommanderSelector } from '@mews-commander/utils';

const EMPTY = '';

export const useDefaultPurchaseOrderNumber = (reservationIds: Array<string>): string => {
    const purchaseOrderNumbers = useCommanderSelector((state) =>
        getReservationPurchaseOrderNumberByIds(state, { ids: reservationIds })
    );

    if (purchaseOrderNumbers.length !== reservationIds.length) {
        return EMPTY;
    }

    const uniquePurchaseOrderNumbers = pipe(
        purchaseOrderNumbers,
        array.map((r) => r.value),
        compactArray,
        primitiveTypeUniq
    );

    return uniquePurchaseOrderNumbers.length === 1 ? uniquePurchaseOrderNumbers[0] : EMPTY;
};
